const DEFALUT_MILLIVOLTS_CONVERSION = 0.0033
const moment = require('moment');

const convertPatientToUnits = (pateint)=>{
    const {weight_unit,height_unit} = pateint
    let {weight,height} = pateint
    if(weight_unit === 'lb') weight = (weight * 2.2).toFixed(1)
    if(height_unit === 'ft') height = (height /30.48).toFixed(1)
    return Object.assign({},pateint,{weight,height})
}

const glucoseConvert = (value, unit) => {
  if (!value) return null;
  if (unit === 'mmol/L') return Math.ceil(value / 18);
  return value;
};

const weightConvert = (value, unit) => {
  if (!value) return null;
  if (unit === 'lb') return (value * 2.2046).toFixed(1);
  return value;
};

const temperatureConvert = (value, unit) => {
  if (!value) return null;
  if (unit === '°F') return Math.round((value * 9) / 5 + 32);
  return value;
};

const convertTimeToNum = (_time, format) => {
  let time = format ? moment(_time, format) : moment(_time)
  time = time.hours() + time.minutes() / 60;
  return time
};

/**
 * This function is needed because different watch versions produce different
 * ecg signals which require a different conversion value
 */
const setEcgConversionFactor = (fwVersion) => { 
  const nums = fwVersion?.split('.')
  const majVersion   = +nums?.[0] || 0 
  const minVersion   = +nums?.[1] || 0 
  const patchVersion = +nums?.[2] || 0 
  if (majVersion > 10) { return 0.0091 }
  if (majVersion < 10) { return 0.0033 }
  if (minVersion > 9 ) { return 0.0091 }
  if (minVersion < 9 ) { return 0.0033 }
  if (minVersion === 9 && patchVersion >= 67) { return 0.0091 }
  if (minVersion === 9 && patchVersion >= 64) { return 0.0019 }
  return DEFALUT_MILLIVOLTS_CONVERSION
}  

module.exports = {
  convertPatientToUnits,
  glucoseConvert,
  weightConvert,
  temperatureConvert,
  setEcgConversionFactor,
  convertTimeToNum
};